import { useEffect, useRef } from "react";

// Pure canvas Matrix rain (0s and 1s). Runs on requestAnimationFrame.
export const MatrixRain = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let columns = 0;
    let drops = [];
    const fontSize = 16;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      columns = Math.floor(canvas.width / fontSize);
      drops = Array.from({ length: columns }, () =>
        Math.floor((Math.random() * canvas.height) / fontSize)
      );
    };
    resize();
    window.addEventListener("resize", resize);

    let last = 0;
    const step = 55; // ms per frame -> slower, calmer rain

    const draw = (t) => {
      raf = requestAnimationFrame(draw);
      if (t - last < step) return;
      last = t;

      // Trail fade
      ctx.fillStyle = "rgba(0, 0, 0, 0.10)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px "JetBrains Mono", monospace`;
      for (let i = 0; i < drops.length; i++) {
        const char = Math.random() > 0.5 ? "1" : "0";
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        // Head brighter, tail dim green
        const bright = Math.random() > 0.975;
        ctx.fillStyle = bright ? "#eafff4" : "#00ff88";
        ctx.fillText(char, x, y);

        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      data-testid="matrix-rain-canvas"
      aria-hidden="true"
      className="fixed inset-0 z-0 h-full w-full opacity-[0.16]"
    />
  );
};
